import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import sysUtils from 'utils/ShopYourStore';
const { wrapHOC } = FrameworkUtils;

const fields = createSelector(
    (_state, ownProps) => ownProps.showCompactPills,
    (_state, ownProps) => ownProps.forceCompactPills,
    (showCompactPills, forceCompactPills) => {
        const isShopYourStoreFilterEnabled = sysUtils.shopYourStoreFilterEnabled();

        return {
            showSingleFilterPill: forceCompactPills || isShopYourStoreFilterEnabled,
            showCompactPills: forceCompactPills || (showCompactPills && isShopYourStoreFilterEnabled)
        };
    }
);

const withFilterPillsProps = wrapHOC(connect(fields));

export {
    fields, withFilterPillsProps
};
